import React from "react";
let onClick = e => {
  console.log("Downloading..");
  window.location.href = "/IRFAN_Developer_Resume_2020.pdf";
};
function ResumeSection() {
  return (
    <div className="col-lg-6 col-md-12 sm-margin-30px-bottom">
      <p className="font-size15 xs-font-size14">
        Experienced Web Developer with a demonstrated history of working in the
        information technology and services industry worked with Capgemini for
        3years and currently working with Sonata software. Skilled in
        JavaScript, Reactjs, Redux, Jquery, Nodejs, HTML5, CSS3, Java, SQL,
        webpack, recharts, semantic-ui, also familier with cloud platforms like
        AWS, GCP, and comfortable with Linux and windows environment. Strong
        engineering professional with a Bachelor of Engineering (B.E.) focused
        in information science from Bapuji Institute of Engineering and
        Technology.
      </p>
      <a className="btn white" onClick={onClick}>
        <i className="fas fa-arrow-alt-circle-down font-size16" />
        <span className="alt-font margin-5px-left">Download My CV</span>
      </a>
    </div>
  );
}
export default ResumeSection;
